import { Modal, ModalButtons, Button, Text } from "@eventsquare/uikit";
import { useAppContext } from "@context/appContext";
import { RiDeleteBinLine } from "@remixicon/react";

interface ClearModalProps {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
}

const ClearModal = ({ showModal, setShowModal }: ClearModalProps) => {
  const { clear } = useAppContext();

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <Modal
      isVisible={showModal}
      closeModal={closeModal}
      icon={RiDeleteBinLine}
      iconColor="error"
    >
      <Text variant="h3" color="error">
        Clear Cart?
      </Text>
      <Text variant="lead">
        Are you sure you want to delete this cart? This action cannot be undone.
      </Text>
      <ModalButtons>
        <Button
          block
          onClick={() => {
            clear();
            setShowModal(false);
          }}
          color="error"
        >
          Clear cart
        </Button>
        <Button
          block
          variant="link"
          color="subtle"
          onClick={() => setShowModal(false)}
        >
          Cancel
        </Button>
      </ModalButtons>
    </Modal>
  );
};

export default ClearModal;
